import type {
    BlockUser,
    CreateUser,
    LoadClientOptions,
    LoadProjectOptions,
    LoadUserAssignments,
    LoadUserById,
    LoadUsers,
    ResetUserPassword,
    SaveUserAssignments,
    UnblockUser,
    UpdateUser
} from '@/domain/use-cases/users.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';
import type { UserProfile } from '@/shared/utils/format-status.js';

export class UserController extends BaseControllerImpl {
    constructor(
        private readonly loadUsersUseCase: LoadUsers,
        private readonly loadUserByIdUseCase: LoadUserById,
        private readonly createUserUseCase: CreateUser,
        private readonly updateUserUseCase: UpdateUser,
        private readonly blockUserUseCase: BlockUser,
        private readonly unblockUserUseCase: UnblockUser,
        private readonly resetUserPasswordUseCase: ResetUserPassword,
        private readonly loadUserAssignmentsUseCase: LoadUserAssignments,
        private readonly saveUserAssignmentsUseCase: SaveUserAssignments,
        private readonly loadClientOptionsUseCase: LoadClientOptions,
        private readonly loadProjectOptionsUseCase: LoadProjectOptions
    ) {
        super();
    }

    public async loadUsers(params?: { search?: string; profile?: string; status?: string; page?: number; limit?: number }) {
        return this.loadUsersUseCase.execute(params);
    }

    public async loadUserById(id: string) {
        return this.loadUserByIdUseCase.execute(id);
    }

    public async createUser(params: {
        name: string;
        email: string;
        phone?: string;
        assignments: Array<{ clientId: string; projectId?: string; profile: UserProfile; isActive: boolean }>;
    }) {
        return this.createUserUseCase.execute(params);
    }

    public async updateUser(id: string, params: { name: string; phone?: string }) {
        return this.updateUserUseCase.execute(id, params);
    }

    public async blockUser(id: string) {
        return this.blockUserUseCase.execute(id);
    }

    public async unblockUser(id: string) {
        return this.unblockUserUseCase.execute(id);
    }

    public async resetUserPassword(id: string) {
        return this.resetUserPasswordUseCase.execute(id);
    }

    public async loadUserAssignments(userId: string) {
        return this.loadUserAssignmentsUseCase.execute(userId);
    }

    public async saveUserAssignments(userId: string, assignments: Array<{ clientId: string; projectId?: string; profile: UserProfile; isActive: boolean }>) {
        return this.saveUserAssignmentsUseCase.execute(userId, assignments);
    }

    public async loadClientOptions() {
        return this.loadClientOptionsUseCase.execute();
    }

    public async loadProjectOptions(clientId: string) {
        return this.loadProjectOptionsUseCase.execute(clientId);
    }
}
